import { maybeLog } from '../utils';
import { apolloService } from '../../services';
import { COURSE_LIST_QUERY, sendCourseTracking } from '../../gql';
import { getEnv } from 'app/utils';
import { buildCoursePath } from '../../utils';

/**
 * Intended to be triggered when a course is launched. This event will actually
 * handle the launching of a course.
 */
export async function launchCourse( { courseId, token, debug = false } ) {
    // Validate incomming parameter data.
    const isValidCourseId = Boolean( courseId );

    maybeLog( debug, `Attempting to launch course with id '${ courseId }'.` );

    if ( isValidCourseId ) {
        // TODO: Find nicer way to fetch course list from Apollo cache?
        const courseList = apolloService.cache.readQuery( { query: COURSE_LIST_QUERY } )?.courseList?.courses;
        const courseDetails = courseList.find( ( data ) => ( data.id === courseId ) );
        let doesCourseExist = Boolean( courseDetails );

        // If we don't already have the target course's details, attempt to retrieve
        // more information on the course (since we need more information for course
        // tracking).
        if ( !doesCourseExist ) {
            // TODO: Attempt to fetch course details using course id from our back-end.
            // ...

            // Update our existence check.
            doesCourseExist = Boolean( courseDetails );
        }

        // If data on the course was managed to be retrieved, course launching and
        // tracking can continue.
        if ( doesCourseExist ) {
            maybeLog( debug, `Course found with id '${ courseId }'. Launching...` );

            // TODO: Remove this forced delay used to mimic some loading time.
            await new Promise( resolve => setTimeout( resolve, 2000 ) );

            // Send course data out for tracking purposes.
            sendCourseTracking( getEnv( window.location.hostname ), token, courseDetails.name );

            // Handle the actual launching of the course.
            const coursePath = buildCoursePath( courseDetails.launchURL ) + '?StandAlone=true&ShowDebug=false';
            window.open( coursePath, '_blank' );

            // Return `true` to signify that the course managed to successfully launch.
            return true;
        }
        else {
            console.warn( `Course with id '${ courseId }' could not be found. Maybe this course doesn't exist in cache?` );

            // If nothing else happened, return `false` to signify that the course with
            // the provided id failed to launch.
            return false;
        }
    }
    else {
        console.warn( `Course with id '${ courseId }' failed to launch. This is likely due to the id being considered invalid.` );

        // If nothing else happened, return `false` to signify that the course with the
        // provided id failed to launch.
        return false;
    }
}
